define(["scriptjs"], function($script) {
  const apiKey = window.googleApiKey || 'AIzaSyBqqSp5BE4fflmvJwZdqNkguYtS3qGCH3E';

  const loadMap = () => {
    return new Promise((resolve, reject) => {
      $script(
        `https://maps.googleapis.com/maps/api/js?key=${apiKey}`,
        "google-maps"
      );

      $script.ready("google-maps", checkMapLoading);

      function checkMapLoading() {
        if (typeof google !== "undefined") return resolve();

        $script(
          `https://maps.google.cn/maps/api/js?key=${apiKey}`,
          "google-maps-cn"
        );

        $script.ready("google-maps-cn", () => {
          if (typeof google !== "undefined") {
            return resolve();
          }

          return reject();
        });
      }
    });
  };

  return loadMap;
});
